var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"MessageSperator box-separator"},[_c('span',[_vm._v(_vm._s(_vm._f("seperatorDateTimeFormat")(_vm.message.timestamp)))])])}
var staticRenderFns = []

export { render, staticRenderFns }